import { useEffect, useState } from "react";

export const WhatsAppSelect = ({ name, value, onChange }) => {
  const [state, setState] = useState([]);
  return (
    <select
      className="select-whatsapp"
      name={name}
      value={value}
      onChange={onChange}
    >
      <option value="C">Consolidado</option>
      <option value="S">Si</option>
      <option value="N">No</option>
    </select>
  );
};
